import WeatherAlertsTabs from './weather-alerts-tabs';

const weatherAlertsTabsConfig = {
  name: 'weatherAlertsTabs',
  class: WeatherAlertsTabs,
  querySelector: {
    conditionsTab: '#conditions',
    conditionsNav: '.tabs__nav li a[href="#conditions"]',
  },
  querySelectorAll: {
    navLinks: '.tabs__nav li a',
  },
};

export default weatherAlertsTabsConfig;
